$(document).ready(function(){

	// fancybox
    $(".fancybox").fancybox();
    $(".gallery li a").fancybox();

    // Mobile menu (manueel breakpoint aanpassen in scss)

    // EqualHeight
    $(window).resize(equalHeight);

    // Dismiss alert
    $(".alert .icon-cross, #site_alert .alert").on('click', function(e) {
        e.preventDefault();
        $(this).parent().remove();
    });

	// toggle search
    $(".toggle-search").on('click', function(e) {
        $('#searchbar').toggleClass("active");
		$('#searchbar input').focus();
    });

	// List-toggle
    $(".list-toggle li .label").on('click', function(e) {
        $(this).parent().siblings().removeClass("active");
        $(this).parent().toggleClass("active");
    });
    $(".list-toggle li:first-child .label").trigger('click');

    // Product-highlights (landingpage Boxby): klik op een productafbeelding
    // vouwt de bijbehorende highlight open. Er staat er altijd precies een open;
    // klikken op het product dat al openstaat doet niets.
    var $productHighlights = $('.product-highlight');

    if ($productHighlights.length > 0) {
        // Gedelegeerd, want slick kloont de slides bij het initialiseren van de
        // slider en die klonen krijgen geen direct gebonden handlers mee.
        $('body').on('click', '.product-toggle', function(e) {
            e.preventDefault();

            var target = $(this).data('target');

            // Staat dit product al open, dan blijft het open: er moet er altijd
            // een actief zijn, dus dichtklappen is geen optie.
            if ($(target).hasClass('active')) {
                return;
            }

            // Sluit wat openstaat; het doel gaat hieronder meteen weer open.
            $('.product-toggle').removeClass('active');
            $productHighlights.filter('.active').removeClass('active')
                .stop(true, true).slideUp(400);

            // Alle knoppen voor dit product, dus ook de slick-klonen ervan.
            $('.product-toggle[data-target="' + target + '"]').addClass('active');
            $(target).addClass('active').stop(true, true).slideDown(400);
        });
    }

    // Clickable
    $('#intro-blocks ul li, #blogs ul li, #news ul li, #subfooter ul li').mousedown(function(e) {
		switch (e.which) {
		case 1:
			window.location=$(this).find("a").attr("href");
			return false;
		case 2:
			window.open($(this).find("a").attr("href"));
			break;
		}
	});

	// Social media share buttons
	$('.share').on('click', function(e){
		e.preventDefault();
		var target = $(this).attr('href');
		window.open(target, 'popup', 'width = 500, height = 300');
	});

    // Twitterfeed
    if ($('#twitterfeed').length > 0) {
        var config1 = {
            "id": '388314281537568768',
            "domId": 'twitterfeed',
            "showUser": false,
            "maxTweets": 1,
            "enableLinks": true,
            "showInteraction": false,
            "lang": 'nl'
        };
        twitterFetcher.fetch(config1);
    }

    // Responsive table
    var $table = $('.responsive-table table');
    var $fixedColumn = $table.clone().insertBefore($table).removeClass('basis-table').addClass('fixed-column');
    $fixedColumn.find('th:not(:first-child),td:not(:first-child)').remove();
    setTableHeight();

    // Sliders
    $('.slider').slick({
        autoplaySpeed: 5000,
		pauseOnHover: false,
        slidesToScroll: 1,
        draggable: true,
        slidesToShow: 1,
        autoplay: true,
        infinite: true,
        arrows: false,
        dots: true,
        speed: 1000
    });

    $('.slider-brand-main').slick({
        autoplaySpeed: 5000,
        pauseOnHover: false,
        slidesToScroll: 1,
        draggable: true,
        slidesToShow: 1,
        autoplay: true,
        infinite: true,
        arrows: false,
        dots: true,
        speed: 1000
    });

    // Productslider (landingpage Boxby)
    $('.slider-products').slick({
        slidesToScroll: 1,
        slidesToShow: 5,
        draggable: true,
        infinite: false,
        autoplay: false,
        arrows: true,
        dots: false,
        speed: 500,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 3 } },
            { breakpoint: 768, settings: { slidesToShow: 2 } },
            { breakpoint: 480, settings: { slidesToShow: 1 } }
        ]
    });

    // Toon bij eerste bezoek het eerste product alvast uitgeklapt.
    if ($('.product-highlight').length > 0) {
        var $firstToggle = $('.product-toggle').first();
        var firstTarget = $firstToggle.data('target');

        $('.product-toggle[data-target="' + firstTarget + '"]').addClass('active');
        $(firstTarget).addClass('active').show();
    }

	// Smooth scroll
	$('a.scroll_link').click(function(){
		if ($('[name="' + $.attr(this, 'href').substr(1) + '"]').length>0) {
			$('html, body').animate({
		        scrollTop: $('[name="' + $.attr(this, 'href').substr(1) + '"]').offset().top - 64
		    }, 500);
		}
    	return false;
	});

	// Hoofdmenu
    $("body").on('click', '.btn-mobile-menu', function(e){
		e.preventDefault();
		e.stopPropagation();
		$('body').addClass('open_menu');
		$("#menu_header").clone().appendTo("#mobile_menu");
		$(".header-search").clone().appendTo("#mobile_menu");
		$(".header-info .socialmedia").clone().appendTo("#mobile_menu");
    });

    // Toggle overlay
    $('body').on('click', '#mobile_overlay', function(e){
        e.preventDefault();
		$('#mobile_menu').empty();
        $('body.open_menu').removeClass('open_menu');
    });

	// Autofocus
	$('.auto-focus:first').focus();

});

// Equalheight on window load
$(window).load(function(){
    equalHeight();
});


// Scrollto
function goToByScroll(id){
    $('html,body').animate({scrollTop: $("#"+id).offset().top},'slow');
}


// EqualHeight
// Sets multiple divs to the same height
function equalHeight() {
	var windowSize = $(window).width();
	if (windowSize >= 960) {
		$('#block1 .wrapper .content .text, #block1 .wrapper .content .image, #block1 .wrapper .content .image img').css('height','auto').setMinHeight(0);

	} else {
		$('#block1 .wrapper .content .text, #block1 .wrapper .content .image, #block1 .wrapper .content .image img').css('height','auto');
	}
}
$.fn.setMinHeight = function(setCount) {
    if (setCount == 0) {
        setCount = this.length;
    }
    for(var i = 0; i < this.length; i+=setCount) {
		var curSet = this.slice(i, i+setCount),
			height = 0;
		curSet.each(function() { height = Math.max(height, $(this).height()); })
			.height(height);
    }
    return this;
};


// ResponsiveTable
// Add a fixed column on a responsive-table
function setTableHeight() {
    $('div.responsive-table').each(function(){
        var div = $(this);
        $('table.basis-table tbody tr', div).each(function(i,el) {
            var hgt = $(this).outerHeight();
            $('table.fixed-column tr', div).eq(i).height(hgt);
            $('table.basis-table tbody tr', div).eq(i).height(hgt);
        });
        $('table tbody tr th', div).each(function(i,el) {
            var hgt = $(this).outerWidth();
            $('table.fixed-column', div).eq(i).width(hgt);
        });
    });
}
